import React from 'react';
import { Typography, TYPOGRAPHY_WEIGHT } from '_atoms';
import { ReactComponent as NoCandidates } from 'dist/emptyStates/stepsNoCandidates.svg';
import { useTranslation } from 'react-i18next';

interface EmptyProps {
  hasSearch?: unknown;
}

export const Empty: React.FC<EmptyProps> = ({ hasSearch }) => {
  const { t } = useTranslation();
  return (
    <div className="self-submitted-candidates__empty">
      <NoCandidates />
      <Typography.Title3 weight={TYPOGRAPHY_WEIGHT.BOLD}>
        {hasSearch
          ? t('translation:ssc_dashboard_empty.text_no_candidates_found')
          : t('translation:ssc_dashboard_empty.text_no_candidates_for_review')}
      </Typography.Title3>
      {hasSearch && <Typography.Text>{t('translation:ssc_dashboard_empty.text_try_different_search')}</Typography.Text>}
    </div>
  );
};
